export default "__VITE_ASSET__ae5ff968__"